import '../../less/account.less';
import React from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { isNil, prop, propOr } from 'ramda';
import withUser from '../../withUser';
import LinkAccount from '../errors/LinkAccount';
import SignIn from './SignIn';
import SignOut from './SignOut';
import RequestPassword from './RequestPassword';
import ResetPassword from './ResetPassword';
import NewPasswordRequired from './NewPasswordRequired';
import SignUpWithToken from './SignUpWithToken';

const userAccountExist = user => !isNil(user) && !isNil(prop('email', user));
const userIsConnected = user => userAccountExist(user);
const userStatusIsPending = user => propOr('', 'status')(user) === 'pending';
const userMustUpdateIsPassword = user => propOr(false, 'resetPasswordRequired', user);

const Account = ({
  user,
  match
}) => {
  const matchUrl = prop('url', match);
  return (
    <Switch>
      <Route exact path={`${matchUrl}/signout`} component={SignOut}/>
      {userIsConnected(user) && userMustUpdateIsPassword(user) &&
        <Route exact path={`${matchUrl}/newpasswordrequired`} component={NewPasswordRequired}/>}
      {userAccountExist(user) && <Redirect to="/" />}
      <Route exact path={`${matchUrl}/lien-invalide`} component={LinkAccount} />
      <Route exact path={`${matchUrl}/signin`} component={SignIn}/>
      {userStatusIsPending(user) && <Redirect to="/account/signin"/>}
      <Route exact path={`${matchUrl}/signup`} component={SignUpWithToken} />
      <Route exact path={`${matchUrl}/resetpasswordrequest`} component={RequestPassword}/>
      <Route exact path={`${matchUrl}/resetpassword`} component={ResetPassword}/>
    </Switch>
  );
};

export default withRouter(withUser(Account));
